import { collectibleAssets, featuredLesson, type AppImage } from '../lib/appAssets'
import { dinoLesson } from '../lib/brandAssets'

export interface Badge extends AppImage {
  name: string
}

/** Real named badges from the app. One badge is earned per completed adventure. */
export const badges: Badge[] = [
  dinoLesson.badge,
  featuredLesson.collectible,
  ...collectibleAssets,
]
